module.exports = __webpack_public_path__ + "static/media/bg.f6764411.png";